import React from 'react';

export const useMounted = (): boolean => {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => setIsMounted(true));

    return () => {
      setIsMounted(false);
    };
  }, []);

  return isMounted;
};
